import styled from 'styled-components';

/**
 * Caps the disclosure body so the long Terms and Conditions copy scrolls within a fixed-height
 * modal rather than growing it past the viewport. Short copy (Privacy Notice) is unaffected.
 */
export const DisclosureBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-height: 60vh;
    overflow-y: auto;
`;

/**
 * Consent section wrapper. The divider colour is a literal rather than a theme token because this
 * component is shared across hosts, whose styled-components themes differ.
 */
export const ConsentSection = styled.div`
    border-top: 0.0625rem solid #b2b2b2;
    padding-top: 1.143rem;
    margin-bottom: 1rem;
`;

/** Checkbox label block — the agreement line with its inline links, plus the acknowledgement beneath. */
export const ConsentLabel = styled.span`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;
